import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 8
	render() {
		const style = {
			st56: {
				opacity: 0.8,
			},
			st18: {
				fill: '#222222',
			},
			st119: {
				opacity: 0.5,
			},
			st2: {
				fill: '#FFFFFF',
			},
			st52: {
				fill: '#1C1C1C',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="61.7626823" cy="19.5277004" />
				<g style={style.st56}>
					<polygon style={style.st18} points="5.7134571,10.706543 9.1328459,30.07477 17.9452572,39.4436226 32.521244,41.3254089
						43.98246,37.6245346 50.1730576,28.0594749 51.3322792,14.4047852 45.1533775,6.5879292 24.5371094,5.019043
						7.0371094,5.019043" />
					<polygon style={style.st18} points="117.332283,10.706543 113.9128952,30.07477 105.1004791,39.4436226 90.524498,41.3254089
						79.0632782,37.6245346 72.8726807,28.0594749 71.7134552,14.4047852 77.8923569,6.5879292 98.5086288,5.019043
						116.0086288,5.019043" />
				</g>
				<g style={style.st119}>
					<rect x="3.9213662" y="13.5469389" transform="matrix(0.7049673 -0.7092398 0.7092398 0.7049673 -6.076673 20.485815)" style={style.st2} width="35.3271904" height="7.9998727" />
					<rect x="9.6167994" y="20.5192566" transform="matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -6.6863627 28.8957787)" style={style.st2} width="43.8406219" height="3.9995728" />
					<rect x="68.9213638" y="12.5469389" transform="matrix(0.7049673 -0.7092398 0.7092398 0.7049673 13.8096933 66.2913742)" style={style.st2} width="35.3271904" height="7.9998727" />
					<rect x="74.6167984" y="19.5192566" transform="matrix(0.7071068 -0.7071068 0.7071068 0.7071068 13.0588036 74.564827)" style={style.st2} width="43.8406219" height="3.9995728" />
				</g>
				<path style={style.st18} d="M29.4228516,44.855957c-0.2226562,0-0.4453125-0.0014648-0.6708984-0.0043945
					C5.5302734,44.5551758,4.1181641,26.9785156,3.1845703,15.3476562
					c-0.1142578-1.4204102-0.2246094-2.8032227-0.3671875-4.1186523l6.9589844-0.7539062
					c0.1494141,1.3769531,0.2666016,2.824707,0.3857422,4.3120117c1.1083984,13.8027344,3.0078125,22.8647461,18.6796875,23.0654297
					c6.7197266,0.0893555,11.5683594-1.355957,14.5029297-4.284668c3.5976562-3.590332,4.3515625-9.2949219,4.4726562-15.0263672
					v-4.9121094c0-0.0024414,0-0.0053711,0-0.0083008l3.3916016-0.0361328l-3.1328125-1.2758789
					C50.0390625,7.4892578,55.1123047,4.375,61,4.375h1c5.8876953,0,10.9609375,3.1142578,12.9238281,7.934082l-3.0859375,1.2568359
					l3.3447266,0.0180664v4.8789062c0.1191406,5.6303711,0.8583984,11.2441406,4.3798828,14.8251953
					c2.9814453,3.0307617,7.7763672,4.5234375,14.6611328,4.5639648c0.0820312,0.0004883,0.1630859,0.0009766,0.2441406,0.0009766
					c15.1298828,0,16.9804688-8.3901367,18.2207031-22.171875c0.1650391-1.8388672,0.3212891-3.5756836,0.5439453-5.2827148
					l6.9414062,0.9072266c-0.2050781,1.5673828-0.3554688,3.2358398-0.5136719,5.0024414
					c-1.0234375,11.3754883-2.5693359,28.5439453-25.2119141,28.5444336c-0.0888672,0-0.1767578,0-0.265625-0.0004883
					c-8.8417969-0.0522461-15.2568359-2.2290039-19.6103516-6.6552734
					c-6.3486328-6.4550781-6.4736328-15.949707-6.3984375-23.7958984C67.1132812,12.5449219,64.765625,11.375,62,11.375h-1
					c-2.765625,0-5.1132812,1.1699219-6.1738281,3.0258789c0.0771484,7.9833984-0.0478516,17.6464844-6.5371094,24.1220703
					C44.0214844,42.78125,37.8447266,44.855957,29.4228516,44.855957z" />
				<path style={style.st52} d="M51.3349609,17.894043c-1.6113281,0-3.0214844-1.1035156-3.4013672-2.6801758
					c-0.0078125-0.0292969-1.3652344-5.1430664-5.7695312-6.5629883c-3.1083984-0.8374023-7.3623047-1.5014648-13.046875-1.5068359
					L16.2597656,7.6777344c-0.1269531,0.0205078-0.2568359,0.0336914-0.3886719,0.0395508
					c-4.1972656,0.1894531-6.9697266,4.2055664-6.9970703,4.2460938c-0.7353516,1.0830078-2.0244141,1.6791992-3.3173828,1.5205078
					c-1.2998047-0.1547852-2.4101562-1.0107422-2.8701172-2.2358398l-2-5.3334961
					C0.2929688,4.8637695,0.4267578,3.6875,1.046875,2.7519531c0.6191406-0.9355469,1.6503906-1.5166016,2.7714844-1.5634766
					l25.0820312-1.0415039c0.0488281-0.0019531,0.0966797-0.0029297,0.1455078-0.0029297
					c6.171875,0,10.9902344,0.7036133,14.7021484,1.6772461c0.0400391,0.0097656,0.0800781,0.0205078,0.1201172,0.0317383
					c7.5634766,2.0087891,10.4873047,5.1342773,10.9189453,5.6381836c0.6777344,0.7910156,0.96875,1.8432617,0.7919922,2.8701172
					l-0.7939453,4.625c-0.2802734,1.6367188-1.6728516,2.8505859-3.3330078,2.9057617
					C51.4130859,17.8935547,51.3740234,17.894043,51.3349609,17.894043z" />
				<path style={style.st52} d="M71.6669922,17.8813477c-0.046875,0-0.09375-0.0009766-0.140625-0.0029297
					c-1.6503906-0.0664062-3.0322266-1.2646484-3.3115234-2.8920898l-0.7939453-4.625
					c-0.1767578-1.0268555,0.1142578-2.0791016,0.7919922-2.8701172c0.4316406-0.5039062,3.3554688-3.6293945,10.9189453-5.6381836
					c0.0400391-0.0112305,0.0800781-0.0219727,0.1201172-0.0317383C82.9638672,0.8476562,87.78125,0.144043,93.9541016,0.144043
					c0.0488281,0,0.0966797,0.0009766,0.1455078,0.0029297l25.0820312,1.0415039
					c1.1210938,0.046875,2.1523438,0.6279297,2.7714844,1.5634766c0.6201172,0.9355469,0.7539062,2.1118164,0.3603516,3.1625977
					l-2,5.3334961c-0.4628906,1.2329102-1.578125,2.1020508-2.8867188,2.2490234
					c-1.3076172,0.1450195-2.5888672-0.453125-3.3134766-1.5532227c-0.0146484-0.0209961-2.7871094-4.0371094-6.984375-4.2265625
					c-0.1318359-0.0058594-0.2617188-0.019043-0.3886719-0.0395508L93.8828125,7.144043
					c-5.7119141,0.0053711-9.9794922,0.6757812-13.0947266,1.5224609c-4.3662109,1.4414062-5.7138672,6.5185547-5.7275391,6.5708008
					C74.6630859,16.7910156,73.2597656,17.8813477,71.6669922,17.8813477z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 8
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.276268" cy="10.2733383" />
				<g opacity="0.8">
					<polygon fill="#222222" points="2.7821786,5.598125 4.5944548,15.8632851 9.2650328,20.8287773 16.9903049,21.8261242
						23.0647507,19.8646603 26.345768,14.7951794 26.9601555,7.5581932 23.6853371,3.4152598 12.7587147,2.58375 3.4837143,2.58375" />
				</g>
				<g opacity="0.8">
					<polygon fill="#222222" points="61.940155,5.598125 60.1278801,15.8632851 55.4573021,20.8287773 47.732029,21.8261242
						41.6575851,19.8646603 38.3765678,14.7951794 37.7621803,7.5581932 41.0369987,3.4152598 51.9636192,2.58375
						61.2386208,2.58375" />
				</g>
				<g opacity="0.5">
					<rect x="1.8323705" y="7.1035347" transform="matrix(0.7049673 -0.7092398 0.7092398 0.7049673 -3.2390556 10.6605186)" fill="#FFFFFF" width="18.7234097" height="4.2399325" />
				</g>
				<g opacity="0.5">
					<rect x="4.8509498" y="10.7988634" transform="matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -3.5618277 15.1184874)" fill="#FFFFFF" width="23.2355289" height="2.1197736" />
				</g>
				<g opacity="0.5">
					<rect x="36.2823715" y="6.573535" transform="matrix(0.7049673 -0.7092398 0.7092398 0.7049673 7.3007183 34.9374619)" fill="#FFFFFF" width="18.7234097" height="4.2399325" />
				</g>
				<g opacity="0.5">
					<rect x="39.3009491" y="10.2688637" transform="matrix(0.7071068 -0.7071068 0.7071068 0.7071068 6.90311 39.323082)" fill="#FFFFFF" width="23.2355289" height="2.1197736" />
				</g>
				<path fill="#222222" d="M15.3481579,23.6973152c-0.1180077,0-0.2360153-0.0007763-0.3555765-0.0023308
					C2.6850913,23.5379009,1.9366734,14.222271,1.4418687,8.0579147C1.3813121,7.3050976,1.3228258,6.572207,1.2472594,5.8750291
					l3.6882617-0.39957c0.0791893,0.729785,0.1412988,1.4970946,0.2044435,2.2853661
					c0.587451,7.3154497,1.5941405,12.1183157,9.9002342,12.2246771c3.5614557,0.0473595,6.1312304-0.7186565,7.686553-2.270874
					c1.9067574-1.9028749,2.3063278-4.9263077,2.3705082-7.963974V7.1472363c0-0.0012941,0-0.0028467,0-0.0043993
					l1.7975483-0.0191507L25.234417,6.4474707c1.0403328-2.5545068,3.7291508-4.2050633,6.8496284-4.2050633h0.5300026
					c3.1204758,0,5.8092957,1.6505566,6.8496284,4.2050633l-1.6355476,0.6661229l1.7727051,0.0095754v2.5858202
					c0.0631447,2.9840965,0.4549522,5.9593945,2.3213387,7.8573542c1.5801659,1.6063023,4.1214752,2.3974209,7.770401,2.4189014
					c0.0434761,0.0002575,0.0864334,0.0005169,0.1293945,0.0005169c8.018837,0,8.9996452-4.4467726,9.656971-11.7510939
					c0.087471-0.9745994,0.1702843-1.895112,0.2882919-2.7998385l3.6789436,0.4808297
					c-0.1086922,0.8307133-0.1883965,1.7149954-0.2722435,2.6512938
					c-0.5424232,6.0290089-1.3617516,15.1282911-13.3623161,15.1285505c-0.0471001,0-0.0936813,0-0.1407814-0.0002594
					c-4.6861534-0.0276909-8.0861244-1.1813717-10.393486-3.5272942c-3.3647766-3.4211922-3.4310265-8.4533453-3.3911705-12.6118259
					c-0.5620918-0.9836574-1.8063507-1.6037159-3.2721291-1.6037159h-0.5300026
					c-1.4657803,0-2.7100372,0.6200585-3.2721272,1.6037159c0.0408878,4.2312007-0.025362,9.3526363-3.4646683,12.7846966
					C23.085434,22.5977192,19.8117523,23.6973152,15.3481579,23.6973152z" />
				<path fill="#1C1C1C" d="M26.9615765,9.4075003c-0.8540039,0-1.601387-0.5848637-1.8027248-1.4204936
					c-0.0041409-0.0155272-0.7235756-2.7258248-3.0578518-3.4783835C20.4535484,4.0647998,18.1989784,3.7128468,15.1861563,3.71
					L8.3717222,3.9928565c-0.0672855,0.010869-0.1361227,0.0178566-0.2059965,0.0209618
					c-2.2245502,0.1004105-3.6939545,2.2289505-3.708447,2.2504296C4.0675426,6.8382421,3.3843393,7.1542234,2.6990659,7.070117
					c-0.6888964-0.082036-1.2773827-0.5356932-1.521162-1.1849947L0.1179039,3.0583692
					c-0.208584-0.5569141-0.1376758-1.180337,0.1909863-1.6761768c0.3281445-0.4958398,0.874707-0.8037988,1.4688867-0.8286425
					l13.2934771-0.5519971C15.0971327,0.0005176,15.1224937,0,15.1483727,0c3.2710934,0,5.8248234,0.372915,7.7921391,0.8889405
					c0.0212212,0.0051758,0.0424404,0.0108691,0.0636616,0.0168213c4.0086422,1.0646582,5.5582714,2.7211671,5.7870407,2.9882374
					c0.3591995,0.4192381,0.5134373,0.9769287,0.4197559,1.521162l-0.4207897,2.4512501
					c-0.1485462,0.8674612-0.8866119,1.5108109-1.7664948,1.5400534
					C27.0029812,9.4072409,26.9822788,9.4075003,26.9615765,9.4075003z" />
				<path fill="#1C1C1C" d="M37.7375526,9.4007711c-0.0248451,0-0.0496864-0.0005169-0.0745316-0.0015526
					c-0.8747063-0.0351954-1.6070786-0.6702633-1.7551079-1.5328074l-0.4207916-2.4512501
					c-0.0936813-0.5442333,0.0605583-1.1019239,0.4197578-1.521162c0.2287674-0.2670703,1.7783966-1.9235792,5.7870407-2.9882374
					c0.0212212-0.0059521,0.0424423-0.0116455,0.0636597-0.0168213C43.7248955,0.372915,46.2781105,0,49.5497208,0
					c0.0258789,0,0.051239,0.0005176,0.0771179,0.0015527l13.2934761,0.5519971
					c0.5941811,0.0248438,1.1407433,0.3328027,1.4688911,0.8286425c0.3286591,0.4958398,0.3995667,1.1192627,0.1909866,1.6761768
					l-1.0600052,2.8267531c-0.2453308,0.6534424-0.8364029,1.1140866-1.5299606,1.1919823
					c-0.6930351,0.0768604-1.372097-0.2401562-1.7561417-0.8232079c-0.0077629-0.0111279-1.477169-2.139668-3.7017174-2.2400784
					c-0.0698738-0.0031052-0.13871-0.0100927-0.2059975-0.0209618L49.5119362,3.71
					c-3.0273132,0.0028467-5.2891312,0.3581638-6.9402046,0.8069043c-2.3140907,0.7639451-3.0283508,3.454834-3.0355949,3.4825244
					C39.3254814,8.8228951,38.5817223,9.4007711,37.7375526,9.4007711z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 8
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="42.62904" cy="13.56856" />
				<g opacity="0.8">
					<polygon fill="#222222" points="3.67458,7.39375 6.06815,20.95151 12.23684,27.50971 22.44003,28.82696 30.46288,26.23634
						34.7963,19.5408 35.60775,9.98252 31.28252,4.51072 16.85113,3.4125 4.60113,3.4125 				" />
					<polygon fill="#222222" points="81.80775,7.39375 79.41418,20.95151 73.24549,27.50971 63.0423,28.82696 55.01945,26.23634
						50.68603,19.5408 49.87458,9.98252 54.19981,4.51072 68.6312,3.4125 80.8812,3.4125 				" />
				</g>
				<g opacity="0.5">
					<rect x="2.42011" y="9.38203" transform="matrix(0.70497 -0.70924 0.70924 0.70497 -4.278 14.07993)" fill="#FFFFFF" width="24.72903" height="5.59991" />
					<rect x="6.40692" y="14.26265" transform="matrix(0.70711 -0.70711 0.70711 0.70711 -4.7043 19.96781)" fill="#FFFFFF" width="30.68843" height="2.7997" />
					<rect x="47.92011" y="8.68203" transform="matrix(0.70497 -0.70924 0.70924 0.70497 9.64246 46.14382)" fill="#FFFFFF" width="24.72903" height="5.59991" />
					<rect x="51.90691" y="13.56265" transform="matrix(0.70711 -0.70711 0.70711 0.70711 9.11732 51.93615)" fill="#FFFFFF" width="30.68843" height="2.7997" />
				</g>
				<path fill="#222222" d="M20.27115,31.29834c-0.15586,0-0.31172-0.00103-0.46963-0.00308
					C3.54635,31.08779,2.55787,18.78413,1.90435,10.64253C1.82437,9.64824,1.74713,8.68027,1.64732,7.75947l4.87129-0.52773
					c0.10459,0.96387,0.18662,1.97729,0.27002,3.01841c0.77588,9.66191,2.10547,16.00532,13.07578,16.1458
					c4.70381,0.06255,8.09785-0.94917,10.15205-2.99927c2.51836-2.51323,3.04609-6.50644,3.13086-10.51846V9.43975
					c0-0.00171,0-0.00376,0-0.00581l2.37412-0.02529l-2.19297-0.89312c1.37402-3.37388,4.92529-5.55386,9.04668-5.55386h0.7
					c4.12138,0,7.67265,2.17998,9.04668,5.55386l-2.16016,0.87978l2.34131,0.01265v3.41523
					c0.0834,3.94126,0.60088,7.8709,3.06592,10.37764c2.08701,2.12153,5.44346,3.16641,10.26279,3.19477
					c0.05742,0.00034,0.11416,0.00068,0.1709,0.00068c10.59092,0,11.88633-5.8731,12.75449-15.52031
					c0.11552-1.28721,0.2249-2.50298,0.38076-3.6979l4.85899,0.63506c-0.14355,1.09717-0.24883,2.26509-0.35957,3.50171
					c-0.71641,7.96284-1.79853,19.98076-17.64834,19.9811c-0.06221,0-0.12373,0-0.18594-0.00034
					c-6.18926-0.03657-10.67979-1.5603-13.72725-4.65869c-4.44404-4.51855-4.53154-11.16479-4.4789-16.65713
					c-0.74238-1.29917-2.38574-2.11811-4.32168-2.11811h-0.7c-1.93594,0-3.5793,0.81895-4.32168,2.11811
					c0.054,5.58838-0.03349,12.35254-4.57597,16.88545C30.49019,29.84604,26.16646,31.29834,20.27115,31.29834z" />
				<path fill="#1C1C1C" d="M35.60963,12.425c-1.12793,0-2.11504-0.77246-2.38095-1.87612
					C33.2232,10.52837,32.27301,6.94873,29.19,5.95479C27.01412,5.3686,24.03639,4.90376,20.05719,4.9l-9.00019,0.37358
					c-0.08887,0.01436-0.17978,0.02358-0.27207,0.02769c-2.93809,0.13262-4.87881,2.9439-4.89795,2.97227
					C5.37223,9.03164,4.46988,9.44897,3.5648,9.33789C2.65494,9.22954,1.87769,8.63037,1.55572,7.7728l-1.4-3.73345
					c-0.27549-0.73555-0.18184-1.55894,0.25225-2.21382c0.4334-0.65488,1.15527-1.06162,1.94004-1.09443l17.55742-0.72905
					C19.93961,0.00068,19.9731,0,20.00728,0c4.32031,0,7.69316,0.49253,10.2915,1.17407
					c0.02803,0.00684,0.05606,0.01436,0.08408,0.02222c5.29443,1.40615,7.34111,3.59399,7.64326,3.94673
					c0.47441,0.55371,0.67813,1.29028,0.5544,2.00908l-0.55576,3.2375c-0.19619,1.1457-1.171,1.99541-2.33311,2.03403
					C35.66431,12.42466,35.63697,12.425,35.60963,12.425z" />
				<path fill="#1C1C1C" d="M49.84205,12.41611c-0.03281,0-0.06562-0.00068-0.09843-0.00205
					c-1.15527-0.04648-2.12256-0.88525-2.31807-2.02446l-0.55576-3.2375c-0.12373-0.7188,0.07998-1.45537,0.55439-2.00908
					c0.30215-0.35273,2.34883-2.54058,7.64326-3.94673c0.02803-0.00786,0.05606-0.01538,0.08408-0.02222
					C57.74986,0.49253,61.12203,0,65.44302,0c0.03418,0,0.06768,0.00068,0.10186,0.00205L83.1023,0.7311
					c0.78477,0.03281,1.50665,0.43955,1.94004,1.09443c0.43408,0.65488,0.52773,1.47827,0.25224,2.21382L83.89459,7.7728
					c-0.32403,0.86304-1.10469,1.47144-2.02071,1.57432c-0.91533,0.10151-1.81221-0.31719-2.31944-1.08726
					c-0.01025-0.0147-1.95097-2.82598-4.88906-2.95859c-0.09229-0.0041-0.1832-0.01333-0.27207-0.02769L65.39313,4.9
					c-3.99834,0.00376-6.98565,0.47305-9.16631,1.06572c-3.05635,1.00898-3.99971,4.56299-4.00928,4.59956
					C51.93932,11.65288,50.95699,12.41611,49.84205,12.41611z" />
			</g>
		);
	}
}


function Sunglasses(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisSunglasses = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisSunglasses)) {
		return null;
	}

	return <ThisSunglasses {...props} />;
}

export default Sunglasses;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Sunglasses.js